const MAX_BACKGROUND_MUSIC_FILE_SIZE = 50 * 1024 * 1024;

const FACEBOOK = 'https://www.facebook.com/sound/collection/';

const YOUTUBE = 'https://www.youtube.com/audiolibrary';

export { MAX_BACKGROUND_MUSIC_FILE_SIZE, FACEBOOK, YOUTUBE };
